<template>
  <div>
    <UserListHeader
      :users="users"
      :defaultSort="sortKey"
      @add-user="openAddUserModal"
      @sorted="sortedUsers = $event"
    />

    <UsersList
      :users="sortedUsers"
      :loading="isLoading"
      @user-edit="handleEdit"
      @user-delete="handleDelete"
    />

    <AddUserModal ref="userModal" @user-added="fetchData" :roles="roles" :devices="devices"/>

    <DeleteUserModal
      ref="deleteModal"
      :user="userToDelete"
      @deleted="fetchData"
    />
  </div>
</template>

<script>
import userService from "@/services/userService.js";
import AddUserModal from "@/components/User/AddUserModal.vue";
import DeleteUserModal from "@/components/User/DeleteUserModal.vue";
import UsersList from "@/components/User/UserList.vue";
import UserListHeader from "@/components/User/UserListHeader.vue";

export default {
  emits: ["updateTitle"],
  components: {
    AddUserModal,
    DeleteUserModal,
    UsersList,
    UserListHeader,
  },
  data() {
    return {
      sortKey: "id",
      users: [],
      sortedUsers: [],
      isLoading: true,
      userModalMode: "add",
      selectedUser: null,
      userToDelete: null,
      roles: [],
      devices: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const data = await userService.getUsers();
        this.users = data.users;
        this.roles = data.roles;
        this.devices = data.devices;
        this.sortedUsers = [...this.users];
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.isLoading = false;
      }
    },
    openAddUserModal() {
      this.$refs.userModal.show();
    },
    handleEdit(user) {
      console.log("Edit user", user);
    },
    handleDelete(user) {
      console.log("Delete user", user);
      this.userToDelete = user;
      this.$refs.deleteModal.show();
    },
  },
};
</script>
